export * as generalTab from './general';
